import React from 'react'
import { Box, Typography } from '@mui/material'
import { fmtNum } from './pushUtils'
import type { Campaign } from './types'

const Tile: React.FC<{ label: string; value?: number; hint?: string; color: string }> = ({ label, value, hint, color }) => (
    <Box sx={{
        background: 'linear-gradient(135deg, #2a2a2a 0%, #222 100%)', border: '1px solid #333', borderRadius: '14px', p: 2,
        position: 'relative', overflow: 'hidden', height: '100%',
        '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: `linear-gradient(90deg, ${color}00, ${color}, ${color}00)` },
    }}>
        <Typography sx={{ fontSize: 10, color: '#6f6f6f', textTransform: 'uppercase', letterSpacing: '0.1em', mb: 1 }}>{label}</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 800, color, letterSpacing: '-0.02em' }}>{fmtNum(value)}</Typography>
        {hint && <Typography sx={{ fontSize: 10, color: '#5a5a5a', mt: 0.5 }}>{hint}</Typography>}
    </Box>
)

const grid = (cols: number) => ({
    display: 'grid', gap: 2, mb: 3,
    gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: `repeat(${cols}, 1fr)` },
})

const CounterCards: React.FC<{ campaign: Campaign }> = ({ campaign }) => {
    const c = campaign.counters
    return (
        <>
            <Typography sx={{ fontSize: 12, color: '#898989', textTransform: 'uppercase', letterSpacing: '0.08em', mb: 1 }}>Users</Typography>
            <Box sx={grid(5)}>
                <Tile label="Targeted" value={c?.matched} hint="Matched in audience" color="#e0e0e0" />
                <Tile label="Attempted" value={c?.attempted} color="#3b82f6" />
                <Tile label="Accepted by Firebase" value={c?.sent} hint="Sent (>= 1 device)" color="#10b981" />
                <Tile label="Failed" value={c?.failed} hint="All devices failed" color="#ef4444" />
                <Tile label="Skipped" value={c?.skipped} hint="No eligible device" color="#f59e0b" />
            </Box>
            <Typography sx={{ fontSize: 12, color: '#898989', textTransform: 'uppercase', letterSpacing: '0.08em', mb: 1 }}>Devices</Typography>
            <Box sx={grid(4)}>
                <Tile label="Total devices" value={c?.devicesTotal} color="#e0e0e0" />
                <Tile label="Accepted by Firebase" value={c?.devicesAccepted} color="#10b981" />
                <Tile label="Failed" value={c?.devicesFailed} color="#ef4444" />
                <Tile label="Pending" value={c?.devicesPending} color="#3b82f6" />
            </Box>
        </>
    )
}

export default CounterCards
